import {React, useEffect } from 'react';
import '../components/guide/StyleGuide.css'
import ColorGuide from '../components/guide/ColorGuide';
import FontGuide from '../components/guide/FontGuide';
import ErrorGuide from '../components/guide/ErrorGuide';
import LayoutGuide from '../components/guide/LayoutGuide';
import ModalGuide from '../components/guide/ModalGuide';
import SizeGuide from '../components/guide/SizeGuide';
import gaggle from '../assets//logo.png';
import { useNavigate } from "react-router-dom";

function StyleGuide() {
    useEffect(() => {
        document.title = "Style Guide";  
        document.documentElement.lang = "en";
    }, []);
    const route = useNavigate();
    const route_home = (e) => {
        route("/main/settings");
    }
    return (
        <div id="style_guide"> 
            <h1 className="style_title">Gaggle Style Guide</h1>
            <div className='logo'>
                <img className="gaggle" src={gaggle}></img>
            </div>

            <div className='guides'>
                <FontGuide />
                <SizeGuide />
                <ColorGuide />
                <LayoutGuide />
            <ErrorGuide />
            </div>

            <div className='guides'>
                <ModalGuide />
            </div>

            <div className='guide_button'>
                <button type="button" className='return_button' onClick={route_home}>Return to Settings</button>
            </div>

        </div>
    )
}

export default StyleGuide